import { StorageSerializers, useSessionStorage } from '@vueuse/core'
import { defineStore } from 'pinia'
import type { LoginAnalyze } from '@/models/api/login-analyze'
import type { UserProfile } from '@/models/api/user-profile'
import { SessionStorageKey } from '@library/enums/session-storage-key'
import { useStorage } from '~library/composables'

export interface UserBindingData {
  userProfile: UserProfile
  analyzeData: LoginAnalyze
}

export const useUserBindingStore = defineStore('user-binding', () => {
  const { getStorageKey } = useStorage()

  const _userBindingData = useSessionStorage<UserBindingData | null>(
    getStorageKey(SessionStorageKey.USER_BINDING_DATA),
    null,
    {
      serializer: StorageSerializers.object
    }
  )

  const userBindingData = computed(
    (): UserBindingData | null => _userBindingData.value
  )

  async function setUserBindingData(data: UserBindingData | null) {
    _userBindingData.value = data
  }

  return {
    userBindingData,
    setUserBindingData
  }
})
